import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setEmployeeListsDATASActions,
  getSingleEmployeeActions,
  getEmployeeBranchName,
  getEmployeeBranchZones,
  getEmployeeEReuestlist,
  SetDashboards,
  SettheCompletedOptions,
  SettheAllOptions,
  getSideBarfilesActions,
  setDropDownRenders,
  SetthePendingOptions,
  SettheDeclineOptions,
  SettheApproveOptions,
  ////--filters
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,
  setTheBranchObject, ///--branch----object
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import clientimg from "../../../Assets/AppComponent/icons/Client/Vector.svg";
import clientBranchimg from "../../../Assets/AppComponent/icons/Client/Layer_1.svg";
import empployeeIcons from "../../../Assets/AppComponent/icons/Employee/Group 349.png";
import Regionicons from "../../../Assets/AppComponent/icons/Locationicons/Layer_1 .png";
import "../../../StyleSheet/MainComponent/Management/EmployeeView.scss";
import { NavLink } from "react-router-dom";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import useDebouncedEffect from 'use-debounced-effect';

const EmployeeVerify = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [DeletePopup, setDeletepopup] = useState(false);
  const [DeleteId, setDeleteID] = useState();
  const [EditPopupCall, setEditPopup] = useState(false);
  const [EditID, setEditId] = useState();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [Data, setdatas] = useState([]);
  const [newpages, setNewpage] = useState(1);
  const [search, setsearch] = useState("");
  const [MakeCreate, setCreateBar] = useState(true);
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const navigate = useNavigate();
  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState([]);
  const [multiselect3, setMuliselect3] = useState([]);
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setDatas] = useState({ zone: "", state: "", region: "" });
  const [multiselect, setMuliselect] = useState([]);

  useEffect(() => {
    const payloads = {
      search: "",
      page_size: dtpagesize,
      page: dtpageindex,
      data: data,
    };
    dispatch(setEmployeeListsDATASActions(payloads));
    setdatas(state.EmployeeDATASList.EmployeeListDatas);
    // console.log(
    // state.EmployeeDATASList.EmployeeListDatas,
    // "Emp",
    // state.EmployeeDATASList.Total_Count
    // );
  }, [data , dtpageindex]);

  ///----filter-----
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: currentPage,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);
  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);
  useEffect(() => {
    const Datas = [];
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
      });
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });
      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setDatas({
        ...data,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setDatas({
        ...data,
        region: "",
        zone:"",
      });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setDatas({
        ...data,
        zone: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setDatas({
        ...data,
        zone: "",
      });
      setMuliselect3({ value: "", label: "ALL" });

    }
  };
  const handleSelectChange = (selectedVal) => {
    console.log(selectedVal, "selectedval");
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      console.log(selectedVal, "asfad");
      setDatas({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setDatas({
        ...data,
        state: "",
        region:"",
        zone:"",
      });
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);


  useDebouncedEffect(
    () => {
        if (setSearchDebounance) {
            setSearched({
                ...SearchedVal,
                stateSearch: SearchDebounance.stateSearch,
                regionSearch: SearchDebounance.regionSearch,
                zoneSearch: SearchDebounance.zoneSearch,
            });
        }
    },
    500,
    [SearchDebounance]
);


  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,

    });

};

///---Region-----------------
const handleInputRegion = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        regionSearch: Val,
    });
};
///----Zone---Name
const handleInputZone = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        zoneSearch: Val,
    });
};


  const handlePageChange = (newPage) => {
    if (newPage < state.EmployeeDATASList.Total_Count) {
      setCurrentPage(newpages + 1);
      console.log(newpages, "newpagess");
      setNewpage(newPage + 1);
      const pageEntries = {
        search: search,
        page_size: 10,
        page: newPage,
        data: data,
      };
      dispatch(setEmployeeListsDATASActions(pageEntries));

      console.log("New Page:", newpages);
    }
  };


  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    /// console.log(arg, "args");
    setdtPageindex(arg);
  };


  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};
  // -----Search------------------------
  function tochange(e) {
    console.log("ee", e);
    setsearch(e);

    if (e != undefined && e !== "") {
      const payload = {
        search: e,
        page_size: dtpagesize,
        page: 1,
        data: data,
      };
      // console.log(e, "testnew")
      dispatch(setEmployeeListsDATASActions(payload));
    }
    if (e == "" || search == "") {
      const payload = {
        search: "",
        page_size: dtpagesize,
        page: 1,
        data: data,
      };
      dispatch(setEmployeeListsDATASActions(payload));
    }
  }

  //---Persons---list
  const PersonsList = (id) => {
     console.log(id ,"we7r0we7r90we8r98we90");
    ///------the-----site-transfer----flow----the sidebarfile=---name---as -site--tranfer---then it not move to the
    ///---onboard---employeee----list
    dispatch(setTheBranchObject({value:id.client_id.id,label:id.client_id.client_name}))
   
    ///blacklist
    ///---else-----it --have---to---move---to---the--------site--transfer---user---list
     if (state.SideBarFiles.SideBarFile == "Site Transfer") {
      dispatch(getSingleEmployeeActions(id.client_id.id));
      // console.log(
      //   id.client_id.id,
      //   "listIDs",
      //   state.ClientBranchIDs.SingelEmployeelistes,
      //   id
      // );

      // console.log(
      //   state.EmployeeVerificationsNeed,
      //   "testing",
      //   state.ClientBranchIDs.SingelEmployeelistes
      // );

      dispatch(getEmployeeBranchName(id.client_id.client_name));
      dispatch(getEmployeeBranchZones(id.client_id.zone_id.zone_name));
      dispatch(getEmployeeEReuestlist(id.employee_request));
      dispatch(SetDashboards(1));
      dispatch(SettheCompletedOptions("2")); //----set a first dropdown value completed
      dispatch(SettheAllOptions("1")); ///--set seacond dropdown value All
      dispatch(setDropDownRenders(""));
      dispatch(SetthePendingOptions("3")); ////Pending
      dispatch(SettheDeclineOptions("4")); ///Decline
      dispatch(SettheApproveOptions("5")); //Approves
      navigate("/employeeVerifylist");
     // navigate("/sitetransfer");
    }

    else if (state.SideBarFiles.SideBarFile == "Black list") {
      dispatch(getSingleEmployeeActions(id.client_id.id));
      // console.log(
      //   id.client_id.id,
      //   "listIDs",
      //   state.ClientBranchIDs.SingelEmployeelistes,
      //   id
      // );

      // console.log(
      //   state.EmployeeVerificationsNeed,
      //   "testing",
      //   state.ClientBranchIDs.SingelEmployeelistes
      // );

      dispatch(getEmployeeBranchName(id.client_id.client_name));
      dispatch(getEmployeeBranchZones(id.client_id.zone_id.zone_name));
      dispatch(getEmployeeEReuestlist(id.employee_request));
      dispatch(SetDashboards(1));
      dispatch(SettheCompletedOptions("2")); //----set a first dropdown value completed
      dispatch(SettheAllOptions("1")); ///--set seacond dropdown value All
      dispatch(setDropDownRenders(""));
      dispatch(SetthePendingOptions("3")); ////Pending
      dispatch(SettheDeclineOptions("4")); ///Decline
      dispatch(SettheApproveOptions("5")); //Approves
      navigate("/employeeVerifylist");
     // navigate("/blacklist");
    }

    else {
      // console.log(
      // id,
      // "isfdfds",
      // id.client_id.id,
      // id.client_id.client_name,
      // id.client_id.zone_id.zone_name,
      // id.employee_request
      // );
      //
      dispatch(getSingleEmployeeActions(id.client_id.id));
      // console.log(
      //   id.client_id.id,
      //   "listIDs",
      //   state.ClientBranchIDs.SingelEmployeelistes,
      //   id
      // );

      // console.log(
      //   state.EmployeeVerificationsNeed,
      //   "testing",
      //   state.ClientBranchIDs.SingelEmployeelistes
      // );
      if (
        state.ClientBranchIDs.SingelEmployeelistes != "" &&
        id.client_id.id == state.ClientBranchIDs.SingelEmployeelistes
      ) {
        dispatch(getEmployeeBranchName(id.client_id.client_name));
        dispatch(getEmployeeBranchZones(id.client_id.zone_id.zone_name));
        dispatch(getEmployeeEReuestlist(id.employee_request));
        dispatch(SetDashboards(1));
        dispatch(SettheCompletedOptions("2")); //----set a first dropdown value completed
        dispatch(SettheAllOptions("1")); ///--set seacond dropdown value All
        dispatch(setDropDownRenders(""));
        dispatch(SetthePendingOptions("3")); ////Pending
        dispatch(SettheDeclineOptions("4")); ///Decline
        dispatch(SettheApproveOptions("5")); //Approves

        //window.location.href = "/employeeVerifylist";
        navigate("/employeeVerifylist");
      }
    }




    // console.log(id.id ,"opopopop");
  };

  const columns = [
    {
      Header: "Client Name list",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="ListedNames">
              <div className="IconsDesign">
                <div>
                  <img src={clientimg} />
                </div>
                <div

                // onClick={e =>{
                // PersonsList(row.row.original)
                //}}
                >
                  <span>{row.row.original.client_id.client_name} </span>
                </div>
              </div>
            </div>
          </>
        );
      },
    },
    {
      Header: "Region",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div>
              <div className="IconsDesign">
                <div className="RegionIMg">
                  <img src={Regionicons} />
                </div>

                <span>{row.row.original.client_id.region_id.region_name} </span>
              </div>
            </div>
          </>
        );
      },
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },

    // {
    //   Header: "Request Employees",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         <div>
    //           <div className="IconsDesign">
    //             <div>
    //               <img src={empployeeIcons} />
    //             </div>
    //             {row.row.original.employee_request < 10 ? (
    //               <span> 0{row.row.original.employee_request} Employees </span>
    //             ) : (
    //               <span>{row.row.original.employee_request} Employees </span>
    //             )}
    //           </div>
    //         </div>
    //       </>
    //     );
    //   },
    // },
  ];

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>
              {state.SideBarFiles.SideBarFile == "Site Transfer"
                ? "Site Transfer Branch list"
                : state.SideBarFiles.SideBarFile == "Black list"
                ? "Block List Branch list "
                : state.SideBarFiles.SideBarFile}
            </h3>


          </div>
        </div>
        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col">
            <label for="validationCustom01" class="form-label">
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              placeholder={"Search"}
            />
          </div>
          <div className="col">
            <label for="validationCustom01" class="form-label">
              Region 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
              // placeholder={data.state == ""? "without selected state you can't select Region":"search"}
            />
          </div>
          <div className="col">
            <label for="validationCustom01" class="form-label">
              Zone 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}

              // placeholder={data.state == ""? "without selected state you can't select Zone":data.region == ""? 
            
              // "without selected Region you can't select Zone" :"Search"
              
              // }

              options={nameList4}
              isClearable={true}
              value={multiselect3}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
          
            />
          </div>
        </div>

        {Data != undefined ? (
          <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
            <ReactTable
              data={state.EmployeeDATASList.EmployeeListDatas}
              columns={columns}
              totalItems={state.EmployeeDATASList.Total_Count}
              currentPage={currentPage}
              onChange={tochange}
              setCurrentPage={setCurrentPage}
              pagesize={pagesize}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
              dtpagesize={pageSize}
              dtpageindex={dtpageindex}
              pageindex={pageindex}
              MakeCreate={MakeCreate}
              datacount={state.EmployeeDATASList.Total_Count}
              ViewParts={(e) => {
                PersonsList(e);
              }}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default EmployeeVerify;
